import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetBooksQuery } from "../features/api/apiSlice";
import { setFilter } from "../features/filter/filterSlice";
import Book from "./Book";

const Home = () => {
  const { isError, isLoading, data } = useGetBooksQuery();
  const { search, filterOptions } = useSelector((state) => state.filter);
  const dispatch = useDispatch();

  // render content based on the state of the request
  let content = null;
  if (isLoading) {
    content = <div>Loading...</div>;
  }
  if (isError && !isLoading) {
    content = <div>Something went wrong...</div>;
  }
  if (!isLoading && !isError && data.length > 0) {
    content = data.map((book) => <Book key={book.id} book={book} />);
  }
  if (!isLoading && !isError && data.length > 0 && (search || filterOptions)) {
    content = data
      .filter((book) => {
        if (filterOptions === true) {
          return book.featured === true;
        } else {
          return book;
        }
      })
      .filter((book) => book.name.toLowerCase().includes(search))
      .map((book) => <Book key={book.id} book={book} />);
    // }
  }

  return (
    <main className="py-12 px-6 2xl:px-6 container">
      <div className="order-2 xl:-order-1">
        <div className="flex items-center justify-between mb-12">
          <h4 className="mt-2 text-xl font-bold">Book List</h4>

          <div className="flex items-center space-x-4">
            <button
              className={`lws-filter-btn ${
                filterOptions === false && "active-filter"
              }`}
              onClick={() => dispatch(setFilter(false))}
            >
              All
            </button>
            <button
              className={`lws-filter-btn ${
                filterOptions === true && "active-filter"
              }`}
              onClick={() => dispatch(setFilter(true))}
            >
              Featured
            </button>
          </div>
        </div>
        <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
          {content}
        </div>
      </div>
    </main>
  );
};

export default Home;
